// @flow
import type { ApiExecutorType } from 'types/ApiExecutorType';
import { convertFidBadgesFromApi, convertFidModalesFromApi, convertFidOffresFromApi } from 'services/Fid';

function FidApi(executor: ApiExecutorType) {
  return {
    fetchFidBadges,
    fetchFidModales,
    fetchFidOffres
  };

  function fetchFidBadges() {
    return executor.get(`/ffr/v1/fid_badges`).then(response => convertFidBadgesFromApi(response));
  }

  function fetchFidModales() {
    return executor.get(`/ffr/v1/fid_modales`).then(response => convertFidModalesFromApi(response));
  }

  function fetchFidOffres() {
    return executor.get(`/ffr/v1/fid_offres`).then(response => convertFidOffresFromApi(response));
  }
}

export default FidApi;
